import {
  DRAWER,
  DASHBOARD_LOADING,
  PROJECT_TAB_VALUE,
  DRAGGING_TYPE,
  DRAG_SELECTION,
  SET_FILTER_STATUS,
  FILTER_VEHICLES_BY_STATUS,
  SET_SETTINGS_SAVE_DISABLED,
  SET_CURRENT_VEHICLE_SELECTION,
  SET_INFO_DIALOG_STATE,
  SET_INCOMPLETE_DRAWER_VISIBLE,
  SET_PROJECTS_DISABLED,
  SET_COUNTRY,
  SET_PUBLISH_DISABLED,
  SET_CURRENT_PROJECT_ID,
  SET_DISABLED_VEHICLES_VISIBILITY,
  EMPTY_ROUTES,
  SET_OPTIONS_EXPANDED,
  SET_STOP_TO_SCROLL_ID,
  SET_STOP_SELECT_MODE,
  SET_STOP_SEARCH_MODE,
  SET_ROUTES_SEARCH_MODE,
  ADD_DRIVER_DIALOG_OPENED,
  ADD_VEHICLE_DIALOG_OPENED,
  SET_LOCKED_MATCH_STOP
} from "./types";
import { store } from "../..";
import { setExtendableType, setExtendableId } from "./edit";
import { getActivities, getActivity } from "./actionHelpers";

export function toggleDrawer(val) {
  return {
    type: DRAWER,
    val
  };
}

export function toggleDisabledVehiclesVisibility() {
  return function (dispatch, getState) {
    dispatch({
      type: SET_DISABLED_VEHICLES_VISIBILITY,
      bool: !getState().common.disabledVehiclesVisible
    });
  };
}

export function filterVehiclesByStatus(status) {
  return function (dispatch, getState) {
    let filteredVehicles;
    const vehicles = getState().project.vehicles;
    const vehicleTypes = getState().project.vehicleTypes;
    const downgraded = vehicles.filter(vehicle => vehicle.downgraded);
    const disabled = vehicleTypes.filter(vehicleType =>
      vehicles.every(vehicle => vehicleType.id !== vehicle?.type_id?.id)
    );

    if (!vehicles.length || vehicles.length === vehicleTypes.length) {
      dispatch(setFilterStatus("All vehicles"));
    }

    switch (status) {
      case "Disabled":
        filteredVehicles = [...disabled, ...downgraded];
        break;
      case "Enabled":
        filteredVehicles = [
          ...vehicles.map(vehicle => vehicle?.type_id),
          ...downgraded
        ];
        break;
      default:
        filteredVehicles = [...vehicleTypes, ...downgraded];
        break;
    }
    dispatch({
      type: FILTER_VEHICLES_BY_STATUS,
      arr: filteredVehicles
    });
  };
}

export function setFilterStatus(status) {
  return {
    type: SET_FILTER_STATUS,
    status
  };
}

export function setInfoDialog(obj) {
  return {
    type: SET_INFO_DIALOG_STATE,
    obj
  };
}

export function setProjectsDisabled(bool) {
  return {
    type: SET_PROJECTS_DISABLED,
    bool
  };
}

export function hideInfoDialog(dialogType) {
  return function (dispatch) {
    const infoDialog = store.getState().common.infoDialog;
    if (dialogType === "incompleteAccount") {
      dispatch({
        type: SET_INCOMPLETE_DRAWER_VISIBLE,
        bool: true
      });
    }
    dispatch({
      type: SET_INFO_DIALOG_STATE,
      obj: { ...infoDialog, visible: false }
    });
  };
}

export function setDashboardLoading(val) {
  return {
    type: DASHBOARD_LOADING,
    val
  };
}

export function setProjectTabValue(val) {
  return {
    type: PROJECT_TAB_VALUE,
    val
  };
}

export function setDraggingType(val) {
  return {
    type: DRAGGING_TYPE,
    val
  };
}

export function setSettingsSaveDisabled(val) {
  return {
    type: SET_SETTINGS_SAVE_DISABLED,
    val
  };
}

export function setPublishDisabled(bool) {
  return {
    type: SET_PUBLISH_DISABLED,
    bool
  };
}

export function setManualDragSelection(listId, list) {
  return {
    type: DRAG_SELECTION,
    listId,
    list
  };
}

export function setOptionsExpanded(bool) {
  return {
    type: SET_OPTIONS_EXPANDED,
    bool
  };
}

export function setDragSelectionByArr(listId, list) {
  return {
    type: DRAG_SELECTION,
    listId,
    list
  };
}

export function setDragSelection(listId, itemId, ctrlKey, shiftKey) {
  return (dispatch, getState) => {
    const { common, project, extendable } = getState();
    let { listId: stateListId, list } = common.dragSelection;

    if (listId !== stateListId) {
      list = [];
    }

    if (list.includes(itemId)) {
      list = list.filter(el => el !== itemId);
    } else {
      list.push(itemId);
      /*
      const activity = getActivity(listId, itemId, project);
      if (activity) list.push(itemId);
      else list = [];*/
    }
    /*
    const editingFinishedStop =
      extendable.id &&
      extendable.id !== itemId &&
      extendable.type === "stops" &&
      ["finished", "skipped"].includes(extendable.props.status);

    if (editingFinishedStop) {
      dispatch(setExtendableType(null));
      dispatch(setExtendableId(null));
    }

    if (listId !== stateListId) {
      shiftKey = false;
      ctrlKey = false;
      if (extendable.type !== "unscheduled") {
        dispatch(setExtendableType(null));
        dispatch(setExtendableId(null));
      }
    }

    if (ctrlKey) {
      // ctrl select logic
      if (extendable.id === itemId) {
        return;
      }
      if (list.includes(itemId)) {
        list = list.filter(el => el !== itemId);
      } else {
        const activity = getActivity(listId, itemId, project);
        if (activity) list.push(itemId);
        else list = [];
      }
    } else if (
      shiftKey &&
      !["finished", "skipped"].includes(extendable.props.status)
    ) {
      // shift select logic
      const activities = getActivities(listId, project);

      const lastIndex = activities.findIndex(el => el.id === itemId);
      const firstIndex =
        listId === stateListId && list.length
          ? activities.findIndex(el => el.id === list[list.length - 1])
          : 0;

      const startIndex = Math.min(lastIndex, firstIndex);
      const endIndex = Math.max(lastIndex, firstIndex);

      const addedStops = activities
        .map(stop => stop.id)
        .slice(startIndex, endIndex + 1)
        .filter(id => !list.includes(id));

      list = [...list, ...addedStops];
    } else {
      if (extendable.id === itemId) {
        list = [itemId];
        dispatch({
          type: DRAG_SELECTION,
          listId,
          list
        });
        return;
      }
      if (
        extendable.id &&
        extendable.id !== itemId &&
        extendable.type !== "unscheduled"
      ) {
        dispatch(setExtendableType(null));
        dispatch(setExtendableId(null));
      }

      list = list.includes(itemId) ? [] : [itemId];
    }
    */
    dispatch({
      type: DRAG_SELECTION,
      listId,
      list
    });
  };
}

export const setCurrentProjectId = id => {
  return {
    type: SET_CURRENT_PROJECT_ID,
    id
  };
};

export function setEmptyRoutesVisible(val) {
  return {
    type: EMPTY_ROUTES,
    val
  };
}

export const setCountry = country => {
  return {
    type: SET_COUNTRY,
    country
  };
};

export function setCurrentVehicleSelection(arr) {
  return {
    type: SET_CURRENT_VEHICLE_SELECTION,
    arr
  };
}

export function setStopToScrollId(id) {
  return {
    type: SET_STOP_TO_SCROLL_ID,
    id
  };
}

// FOJW contextual RouteTag: pin/unpin an unscheduled stop's match. Passing the
// currently-locked id toggles it off (see the reducer).
export function setLockedMatchStop(id) {
  return {
    type: SET_LOCKED_MATCH_STOP,
    id
  };
}

export function setStopSelectMode(isStopSelectMode) {
  return {
    type: SET_STOP_SELECT_MODE,
    payload: isStopSelectMode
  };
}

export function setStopSearchMode(isStopSearchMode) {
  return {
    type: SET_STOP_SEARCH_MODE,
    payload: isStopSearchMode
  };
}

export function setRoutesSearchMode(isSearchMode) {
  return {
    type: SET_ROUTES_SEARCH_MODE,
    payload: isSearchMode
  };
}

export function scrollToStop(id) {
  return (dispatch, getState) => {
    const stopId = getState().common.stopToScrollId;
    const list = document.getElementById("routes-list");
    const stop = document.getElementById(`stop-${stopId || id}`);
    if (list && stop) {
      setTimeout(() => {
        list.scrollTo({
          top: stop.offsetTop,
          left: 0,
          behavior: "smooth"
        });
        dispatch(setStopToScrollId(null));
      }, 200);
    }
  };
}

export function openAddDriverDialog() {
  return {
    type: ADD_DRIVER_DIALOG_OPENED,
    payload: true
  };
}

export function openAddVehicleDialog() {
  return {
    type: ADD_VEHICLE_DIALOG_OPENED,
    payload: true
  };
}

export function closeAddVehicleDialog() {
  return {
    type: ADD_VEHICLE_DIALOG_OPENED,
    payload: false
  };
}

export function closeAddDriverDialog() {
  return {
    type: ADD_DRIVER_DIALOG_OPENED,
    payload: false
  };
}
